<app-checkout-layout
  [title]="'checkout.profile.title' | translate"
  [description]="'checkout.profile.description' | translate"
  [backLinkAriaLabel]="'checkout.information.back_link' | translate"
  [backLink]="backLink"
  [hasLargeColumn]="true"
  data-test="checkout-profile-page"
>
  <div class="profile">
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
      <app-form-input-group
        class="block mb-4"
        [label]="'checkout.profile.given_name.label' | translate"
        [errors]="errors('givenName')"
        errorKey="givenName"
      >
        <app-form-input
          #content
          [placeholder]="'checkout.profile.given_name.placeholder' | translate"
          required="true"
          formControlName="givenName"
          data-test="checkout-profile-surname"
        ></app-form-input>
      </app-form-input-group>

      <app-form-input-group
        class="block mb-4"
        [label]="'checkout.profile.family_name.label' | translate"
        [errors]="errors('familyName')"
        errorKey="familyName"
      >
        <app-form-input
          #content
          [placeholder]="'checkout.profile.family_name.placeholder' | translate"
          required="true"
          formControlName="familyName"
          data-test="checkout-profile-name"
        ></app-form-input>
      </app-form-input-group>

      <fieldset class="mb-4">
        <legend class="mb-2 text-grey text-xs">
          {{ 'checkout.profile.gender.label' | translate }}
        </legend>

        <div class="flex">
          <app-form-radio-button
            #controlChild
            [label]="'checkout.profile.gender.female.label' | translate"
            required="true"
            formControlName="gender"
            name="gender"
            [htmlValue]="femaleValue"
            class="block w-1/2"
            data-test="checkout-profile-female"
          ></app-form-radio-button>

          <app-form-radio-button
            #controlChild
            [label]="'checkout.profile.gender.male.label' | translate"
            required="true"
            formControlName="gender"
            name="gender"
            [htmlValue]="maleValue"
            class="block w-1/2"
            data-test="checkout-profile-male"
          ></app-form-radio-button>

          <app-form-radio-button
            #controlChild
            [label]="'checkout.profile.gender.undefined.label' | translate"
            required="true"
            formControlName="gender"
            name="gender"
            [htmlValue]="undefinedValue"
            class="block w-1/2"
            data-test="checkout-profile-male"
          ></app-form-radio-button>
        </div>
      </fieldset>

      <app-form-input-group
        class="block w-full mb-4"
        [label]="'checkout.profile.birthdate.label' | translate"
        [errors]="errors('birthdate')"
        errorKey="birthdate"
      >
        <app-form-input
          #content
          type="date"
          min="1900-01-01"
          [max]="majorityBirthDate"
          required="true"
          formControlName="birthdate"
          [placeholder]="'checkout.profile.birthdate.placeholder' | translate"
          data-test="checkout-profile-birthdate"
        ></app-form-input>
      </app-form-input-group>

      <fieldset class="mb-4">
        <app-form-checkbox
          class="block mt-4"
          formControlName="consent"
          [label]="'checkout.profile.consent.checkbox.label' | translate"
          (change)="consent = !consent"
        ></app-form-checkbox>
      </fieldset>

      <app-mobile-fixed-panel
        [parentElementRef]="appProfileElementRef"
        class="pt-2"
      >
        <button
          app-vtmn-play-button
          type="{{ ctaType }}"
          [size]="vtmnPlayButtonSize.MEDIUM"
          [disabled]="profileForm.invalid ? true : null"
          [attr.data-disabled]="profileForm.invalid ? true : null"
          data-test="submit-checkout-profile-form"
        >
          {{ 'checkout.profile.confirmation_button' | translate }}
        </button>
      </app-mobile-fixed-panel>
    </form>
  </div>
</app-checkout-layout>
